function truncateName(str, n) {
    return (str && str.length > n) ? str.substr(0, n - 1) + '...' : str;
};

export default truncateName;